export default __webpack_public_path__ + "static/media/immaculate.2c48bb8d.png";